import { ChatBotService } from '@weave/schema-gen-ts/dist/schemas/customization-feature-validator/chat-bot/v1/chat_bot.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaChatBotV1Service = bindHTTP(ChatBotService);
export const serviceName = 'chat-bot-v1' as const;
